module.exports = __webpack_public_path__ + "static/media/Yelp.1b62bf92.png";